import { buildProvenance } from "@octopusdeploy/build-provenance";
import { resourceFromAttributes } from "@opentelemetry/resources";
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from "@opentelemetry/semantic-conventions";

export const serviceResource = resourceFromAttributes({
    [ATTR_SERVICE_NAME]: "OctopusServer.Frontend",
    [ATTR_SERVICE_VERSION]: buildProvenance.version,
});
